import { createContext, Dispatch, SetStateAction } from 'react';
import IPageConfig from 'rules/interface/config/config.interface';


interface IContext {
    layout: IPageConfig
    setLayout: Dispatch<SetStateAction<IPageConfig>>
}

const LayoutContext = createContext<IContext>({
    layout: {
        layout: null,
        config: {}
    },
    setLayout: () => undefined
});

export default LayoutContext